import React, { useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../AppComponents/Games.scss";
import _ from "lodash";
import GameCard from "../commonComponents/GameCard";
import { useLocation, useHistory } from "react-router-dom";
import { reactLocalStorage } from "reactjs-localstorage";

import ConfirmPopup from "./ConfirmPop";
import config from "../config";

function Unsubscribe({ unsub_mode }) {
  console.log("unsub---", unsub_mode);
  const history = useHistory();
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showUnsubBtn, setShowUnsubBtn] = useState(false);
  const [loading, setLoading] = useState(false);
  const [resultModal, setResultModal] = useState(false);
  const [message, setMessage] = useState("");
  useEffect(() => {
    setLoading(false);
    const showUnSub = reactLocalStorage.get("showUnsub");
    setShowUnsubBtn(showUnSub);
  }, []);
  function handleModal() {
    setShowConfirmModal(!showConfirmModal);
  }

  function handleBtnClick() {
    setLoading(true);
    const url = `${config.get("base")}${config.get("unsubscribe")}`;
    fetch(url, {
      method: "POST",
      body: JSON.stringify({
        uid: reactLocalStorage.get("uid") ? reactLocalStorage.get("uid") : "",
      }),
      headers: config.get("headers"),
    })
      .then((res) => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        (result) => {
          console.log("result message::", result);
          setMessage(result.message);
          setResultModal(true);
          setLoading(false);
          reactLocalStorage.set(
            "show_un_sub",
            JSON.stringify(result.showUnsub)
          );
        },
        (error) => {
          console.log("error:::", error);
          setLoading(false);
        }
      );
  }

  return (
    <>
      {loading ? (
        <div className="ld-bg">
          <div className="lds"></div>
        </div>
      ) : (
        <>
          <div>
            <div className="container m-w">
              <div className="columns is-mobile">
                <div className="column is-full">
                  <div className="card">
                    <div className="card-content ">
                      <div className="display text-black">
                        <div className="text-start">
                          <h3 className="bold text-lg">Subscription Status</h3>
                          <h2 className="mt-4 capitalize">
                            {reactLocalStorage.get("status_display")}
                          </h2>
                        </div>
                        <div className="text-start">
                          <h3 className="bold text-lg">Msisdn</h3>
                          <h2 className="mt-4">
                            {reactLocalStorage.get("msisdn")}
                          </h2>
                        </div>
                      </div>
                    </div>
                    <button
                      className="cancel-btn text-white bold"
                      onClick={() => setShowConfirmModal(true)}
                    >
                      {reactLocalStorage.get("unsub_ok_txt")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {showConfirmModal && (
        <ConfirmPopup
          cancelText={"cancel"}
          message="Are you sure you want to unsubscribe"
          showConfirmModal={showConfirmModal}
          setShowConfirmModal={handleModal}
          loading={loading}
          setLoading={setLoading}
          handleUnsub={handleBtnClick}
          mode={unsub_mode}
        />
      )}
      {resultModal && (
        <div className="modal-bg">
          <div className="model-content">
            <div className="px-4 flex">
              <p className="text-center bold w-full max-w-full break-words ">{message}</p>
            </div>
            <h1 className="text-center bold">
              <button
                className="modalbtn margin text-white button-bg"
                onClick={() => history.push("/")}
              >
                Okay
              </button>
            </h1>
          </div>
        </div>
      )}
    </>
  );
}
export default Unsubscribe;
